export default [

    //Examples
    // {
    //     name: 'napoleon',
    //     type: 'texture',
    //     path: './images/products/napoleon/1.jpg'

    // },

    // {
    //     name: 'ambientSound',
    //     type: 'audio',
    //     path: './sounds/ambient.mp3'

    // },
    {
        name: 'logo',
        type: 'texture',
        path: './images/logo.jpg'

    },
    {
        name: 'envMap',
        type: 'texture',
        path: './environmentMaps/blockadesLabsSkybox/1.jpg'

    },
    {
        name: 'gameScene',
        type: 'gltfModel',
        path: './models/optimisedBoard.glb'

    },




]

